import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { Button } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { filter, fromEvent } from 'rxjs';
import { AuthFacadeService } from '../../../domain/auth/service/auth-facade.service';
import { AuthInformationModalComponent } from '../../../page/main/containers/auth-information-modal/auth-information-modal.component';
import { MainLogicService } from '../../../page/main/services/main-logic.service';
import { FooterComponent } from '../../../page/main/views/footer/footer.component';
import { ExtendedLogoComponent } from '../../../shared/component/extended-logo/extended-logo.component';
import { AuthSelectors } from '../../../shared/store/auth/auth.selectors';
import { ApplicationConfig } from '../../config/application.config';
import { LoggedUserBadgeComponent } from './container/logged-user-badge/logged-user-badge.component';
import { MenuComponent } from './container/menu/menu.component';

@Component({
  selector: 'app-main-layout',
  imports: [
    CommonModule,
    TranslateModule,
    ExtendedLogoComponent,
    MenuComponent,
    Button,
    RouterOutlet,
    FooterComponent,
    RouterLink,
    Dialog,
    AuthInformationModalComponent,
    LoggedUserBadgeComponent,
  ],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss',
})
export class MainLayoutComponent {
  private router = inject(Router);
  public window = window;
  public mainLogicService = inject(MainLogicService);
  public store = inject(Store);
  public authFacadeService = inject(AuthFacadeService);

  public loggedUser$ = this.store.select(AuthSelectors.getCurrentLogged);

  public dialogVisible = false;

  constructor() {
    fromEvent<StorageEvent>(window, 'storage')
      .pipe(
        takeUntilDestroyed(),
        filter(
          (event: StorageEvent) =>
            !!event?.key &&
            event.key === `${ApplicationConfig.applicationName}:auth.account`
        )
      )
      .subscribe((event: StorageEvent) => {
        if (event.newValue === 'null') {
          this.router.navigate(['/auth/login']);
        }
      });
  }

  public openAuthModal(): void {
    this.dialogVisible = true;
  }

  public signout(): void {
    this.authFacadeService.logout();
  }
}
